import { Components, Theme } from '@mui/material/styles';

export const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: {
      backgroundColor: 'white',
    },
    elevation1: {
      boxShadow: '0px 1px 2px 0px #0000004C',
    },
  },
};
